module.exports = new __parcel__URL__("kick_12.183b69d7.mp3").toString();